exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-c2459612] {\n\twill-change: height;\n\t-webkit-transform: translateZ(0);\n\t        transform: translateZ(0);\n\t-webkit-backface-visibility: hidden;\n\t        backface-visibility: hidden;\n\t-webkit-perspective: 1000px;\n\t        perspective: 1000px;\n}\n", ""]);

// exports
